// extracted by mini-css-extract-plugin
export default {"dialpad":"Dialpad_dialpad__YPpwb"};